/* En-tête Maison Sirito : panneau de recherche et tiroir de menu mobile. */

class SiritoHeader extends HTMLElement {
  connectedCallback() {
    this.searchToggle = this.querySelector('[data-sirito-search-toggle]');
    this.searchPanel = this.querySelector('#SiritoSearchPanel');
    this.searchInput = this.querySelector('.sirito-search__input');

    if (this.searchToggle && this.searchPanel) {
      this.searchToggle.addEventListener('click', () => this.toggleSearch());
      this.querySelectorAll('[data-sirito-search-close]').forEach((btn) =>
        btn.addEventListener('click', () => this.closeSearch())
      );
    }

    this.onKeydown = this.onKeydown.bind(this);
    document.addEventListener('keydown', this.onKeydown);
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.onKeydown);
  }

  onKeydown(event) {
    if (event.key !== 'Escape') return;
    if (this.searchPanel && !this.searchPanel.hidden) this.closeSearch();
  }

  toggleSearch() {
    if (this.searchPanel.hidden) {
      this.openSearch();
    } else {
      this.closeSearch();
    }
  }

  openSearch() {
    this.searchPanel.hidden = false;
    this.searchToggle.setAttribute('aria-expanded', 'true');
    // Le champ doit être prêt à recevoir la frappe dès l'ouverture.
    if (this.searchInput) this.searchInput.focus();
  }

  closeSearch() {
    this.searchPanel.hidden = true;
    this.searchToggle.setAttribute('aria-expanded', 'false');
    this.searchToggle.focus();
  }
}

customElements.define('sirito-header', SiritoHeader);

/* --- Tiroir du menu mobile --- */

(function initMobileMenu() {
  const menu = document.getElementById('SiritoMobileMenu');
  const toggle = document.querySelector('[data-sirito-menu-toggle]');
  if (!menu || !toggle) return;

  const panel = menu.querySelector('.sirito-mobile-menu__panel');
  const DUREE_FERMETURE = 260;
  let lastFocused = null;
  let minuterie = null;

  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const finirFermeture = () => {
    menu.classList.remove('sirito-mobile-menu--closing');
    menu.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    if (lastFocused) lastFocused.focus();
  };

  const open = () => {
    // Une réouverture pendant la fermeture repartirait d'un panneau à moitié
    // sorti : on solde d'abord l'animation en cours.
    window.clearTimeout(minuterie);
    menu.classList.remove('sirito-mobile-menu--closing');

    lastFocused = document.activeElement;
    menu.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    const premier = panel.querySelector('a, button');
    if (premier) premier.focus();
  };

  const close = () => {
    if (menu.hidden) return;
    window.clearTimeout(minuterie);

    /* Le panneau doit repartir vers la gauche avant de disparaître. On masque
       à l'échéance plutôt qu'à l'événement animationend : une animation mise
       en pause par le navigateur laisserait sinon le tiroir ouvert pour de
       bon. */
    if (reduceMotion()) {
      finirFermeture();
      return;
    }
    menu.classList.add('sirito-mobile-menu--closing');
    minuterie = window.setTimeout(finirFermeture, DUREE_FERMETURE);
  };

  toggle.addEventListener('click', open);
  menu.querySelectorAll('[data-sirito-menu-close]').forEach((el) => el.addEventListener('click', close));

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !menu.hidden) close();
  });

  /* Glissement vers la gauche pour refermer : c'est le geste attendu d'un
     tiroir, et il évite de viser la croix d'un pouce. Les gestes verticaux
     appartiennent au défilement du menu, on les laisse passer. */
  const SEUIL = 60;
  let departX = null;
  let departY = null;

  panel.addEventListener(
    'touchstart',
    (event) => {
      if (event.touches.length !== 1) return;
      departX = event.touches[0].clientX;
      departY = event.touches[0].clientY;
    },
    { passive: true }
  );

  panel.addEventListener(
    'touchend',
    (event) => {
      if (departX === null) return;
      const arrivee = event.changedTouches[0];
      const dx = arrivee.clientX - departX;
      const dy = arrivee.clientY - departY;
      departX = null;
      departY = null;
      if (dx < -SEUIL && Math.abs(dx) > Math.abs(dy)) close();
    },
    { passive: true }
  );

  // Le focus reste enfermé dans le tiroir tant qu'il est ouvert.
  menu.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab' || menu.hidden) return;
    const focusables = panel.querySelectorAll(
      'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (!focusables.length) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();

/* --- Pastille du panier dans le tiroir de menu ---

   Après un ajout, le tiroir du panier redemande la section « cart-icon-bubble »
   et rafraîchit le bouton panier de l'en-tête. La pastille du menu mobile, elle,
   ne fait partie d'aucune section : elle resterait sur l'ancien compte. On la
   recopie depuis l'en-tête à chaque mise à jour du panier. */

(function synchroniserPastille() {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  const recopier = () => {
    const action = document.querySelector('.sirito-mobile-menu__action[href*="/cart"]');
    if (!action) return;

    const source = document.querySelector('#cart-icon-bubble .sirito-header__cart-count');
    let pastille = action.querySelector('.sirito-mobile-menu__badge');

    if (!source) {
      if (pastille) pastille.remove();
      return;
    }

    if (!pastille) {
      pastille = document.createElement('span');
      pastille.className = 'sirito-mobile-menu__badge';
      pastille.setAttribute('aria-hidden', 'true');
      // Avant le chevron, comme au rendu de la page.
      const fleche = action.querySelector('.sirito-mobile-menu__action-arrow');
      action.insertBefore(pastille, fleche);
    }

    pastille.textContent = source.textContent.trim();
  };

  // L'en-tête est réécrit juste après l'événement : on laisse passer un tour.
  subscribe(PUB_SUB_EVENTS.cartUpdate, () => window.setTimeout(recopier, 0));
})();

/* --- Raccourcis vers le tiroir du panier ---

   Le composant de Dawn branche lui-même le bouton panier de l'en-tête sur le
   tiroir dès qu'il est monté. Restent deux angles morts qu'il ne couvre pas :
   le clic avec une touche de modification, et le raccourci « Panier » du menu
   mobile, qui n'est pas ce bouton-là.

   Rien de tout ceci ne s'applique quand le tiroir n'est pas monté — c'est-à-dire
   quand les deux réglages « Ajouter au panier » sont sur « page ». Les liens
   restent alors de simples liens. */

(function raccourcisPanier() {
  const tiroir = document.querySelector('cart-drawer');
  if (!tiroir) return;

  const clicSimple = (event) =>
    event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;

  /* Dawn coupe court à tous les clics sur le bouton panier, y compris à ceux
     qui demandent explicitement un nouvel onglet. On intercepte ceux-là avant
     lui — en phase de capture sur le document, seule façon de passer devant un
     écouteur déjà posé sur l'élément lui-même — et on laisse le navigateur
     suivre le lien. */
  document.addEventListener(
    'click',
    (event) => {
      if (clicSimple(event)) return;
      const cible = event.target;
      if (!cible || typeof cible.closest !== 'function') return;
      if (!cible.closest('#cart-icon-bubble')) return;
      event.stopPropagation();
    },
    true
  );

  /* Le raccourci « Panier » du menu mobile : on referme d'abord le menu, sans
     quoi deux panneaux se superposeraient. */
  const raccourci = document.querySelector('.sirito-mobile-menu__action[href*="/cart"]');
  if (!raccourci) return;

  raccourci.setAttribute('aria-haspopup', 'dialog');

  raccourci.addEventListener('click', (event) => {
    if (!clicSimple(event)) return;
    // Composant pas encore prêt : le lien fait son office, on ne bloque rien.
    if (typeof tiroir.open !== 'function') return;

    event.preventDefault();

    const menu = document.getElementById('SiritoMobileMenu');
    const fermeture = menu && !menu.hidden ? menu.querySelector('[data-sirito-menu-close]') : null;
    if (fermeture) fermeture.click();

    // On attend la fin du glissement du menu ; la durée est celle de son
    // animation de fermeture.
    window.setTimeout(() => tiroir.open(raccourci), fermeture ? 280 : 0);
  });
})();
